'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _reactIntl = require('react-intl');

var _reactRouterRedux = require('react-router-redux');

var _components = require('../../components');

var _Authorization = require('../../helpers/Authorization');

var _DefaultString = require('../../helpers/DefaultString');

var _Provider = require('../../helpers/Provider');

var _Router = require('../../helpers/Router');

var _TrialExpired = require('./TrialExpired.scss');

var _TrialExpired2 = _interopRequireDefault(_TrialExpired);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TrialExpired = (_dec = (0, _reactRedux.connect)(function (state) {
  return { auth: state.auth };
}, { pushState: _reactRouterRedux.push }), _dec(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(TrialExpired, _Component);

  function TrialExpired() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, TrialExpired);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = TrialExpired.__proto__ || (0, _getPrototypeOf2.default)(TrialExpired)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      provider: null
    }, _this.onAuthorize = function () {
      var path = _Authorization.AuthorizationHelper.authorizeNowPath(_this.state.provider);
      _this.props.pushState((0, _Router.getPath)(_Router.RouterConst.Welcome + '/' + path));
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(TrialExpired, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      (0, _Provider.getProvider)(this.props.auth, function (result) {
        _this2.setState({ provider: result });
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var email = this.props.auth.userInfo ? this.props.auth.userInfo.account.emailAddress : '';

      return _react2.default.createElement(
        'div',
        { className: _TrialExpired2.default.trialExpired },
        _react2.default.createElement(
          'div',
          { className: _TrialExpired2.default.title },
          _react2.default.createElement(_reactIntl.FormattedMessage, _DefaultString.translations.TrialExpiredTitle)
        ),
        _react2.default.createElement(_components.ProviderLogo, { className: _TrialExpired2.default.providerLogo, provider: this.state.provider }),
        _react2.default.createElement(
          'div',
          { className: _TrialExpired2.default.message },
          _react2.default.createElement(_reactIntl.FormattedHTMLMessage, _DefaultString.translations.TrialAuthorizationMessage)
        ),
        _react2.default.createElement(_components.BaseButton, { className: _TrialExpired2.default.button, onClick: this.onAuthorize, buttonString: _DefaultString.translations.AuthorizeNow }),
        _react2.default.createElement(_components.LogoutButton, { className: _TrialExpired2.default.button }),
        _react2.default.createElement(
          'div',
          { className: _TrialExpired2.default.email },
          email
        )
      );
    }
  }]);
  return TrialExpired;
}(_react.Component), _class2.propTypes = {
  auth: _react.PropTypes.object,
  pushState: _react.PropTypes.func.isRequired
}, _temp2)) || _class);
exports.default = (0, _reactIntl.injectIntl)(TrialExpired);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/TrialExpired/TrialExpired.js
// module id = 2026
// module chunks = 0